import oget from 'oget';

const parseAthleteDetailsTimed = (details) => details
.reduce((obj, detail) => {
    const type = detail.name;
    const fields = detail.fields || [];

    oget(
        detail,
        'details',
        []
    )
    .forEach(item => {
        obj[type] = obj[type] || {};
        obj[type].label = type;
        obj[type].values = obj[type].values || [];

        const fieldValues = oget(
            item,
            'values',
            []
        );

        const value = fields
        .reduce((obj, fieldName, index) => ({
            ...obj,
            [fieldName]: fieldValues[index]
        }), {});

        obj[type].values.push(
            value
        );
    });

    if (obj.LapTimes) {
        obj.LapTimes.values = obj.LapTimes.values
        .sort((itemA, itemB) => (
            +itemB.Lap - itemA.Lap
        ));
    }

    return obj;
}, {});

export default parseAthleteDetailsTimed;



// WEBPACK FOOTER //
// ./src/views/Home/updater/parse-athlete-details-timed.js